module.exports = __webpack_public_path__ + "img/office-4.8d697807.webp";